import DataTable from "react-data-table-component";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState, useRef } from "react";
import { AiFillDelete, AiFillLock, AiFillUnlock } from "react-icons/ai";
import { TbEdit } from "react-icons/tb";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { MdPassword } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsPlusCircleFill } from "react-icons/bs";
import api from "../../../api/axiosInstance";
const OperatorUsers = (props) => {
  const { operatorId, rolesUpdateKey } = props;
  const pId = useParams();
  const [operatorRoles, setOperatorRoles] = useState([]);
  const [operatorUsers, setOperatorUsers] = useState([]);
  const [operatorInfo, setOperatorInfo] = useState({});
  const [show, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmAction, setConfirmAction] = useState({
    type: "",
    userId: null,
    userEmail: null,
    userData: null,
    message: "",
    title: "",
  });
  const [errors, setErrors] = useState({});

  // Refs for focusing on error fields
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const emailRef = useRef(null);
  const roleIdRef = useRef(null);

  const handleClose = () => {
    setShow(false);
    setIsEdit(false);
    setOperatorInfo({});
    setErrors({});
  };
  const handleShow = () => {
    setIsEdit(false);
    setShow(true);
    setOperatorInfo({});
    setErrors({});
  };

  const handleCloseConfirm = () => {
    setShowConfirmDialog(false);
    setConfirmAction({
      type: "",
      userId: null,
      userEmail: null,
      userData: null,
      message: "",
      title: "",
    });
  };

  const handleConfirm = () => {
    switch (confirmAction.type) {
      case "lock":
        LockUserAction(confirmAction.userEmail);
        break;
      case "unlock":
        UnLockUserAction(confirmAction.userEmail);
        break;
      case "reset":
        ResetPasswordAction(confirmAction.userId);
        break;
      case "delete":
        DeleteOperatorUserAction(confirmAction.userId);
        break;
      default:
        break;
    }
    handleCloseConfirm();
  };

  const showConfirmation = (
    type,
    userId,
    userEmail,
    userData,
    title,
    message,
  ) => {
    setConfirmAction({ type, userId, userEmail, userData, message, title });
    setShowConfirmDialog(true);
  };

  const ResetPasswordAction = (userId) => {
    var config = {
      method: "Patch",
      url: process.env.REACT_APP_API_URL + "Users/ResetUserPassword/" + userId,
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config).then(function (response) {
      console.log(response);
      if (response.data.statusCode === 200) {
        toast.success("Reset Email Sent");
      }
    });
  };

  const ResetPassword = (userData) => {
    showConfirmation(
      "reset",
      userData.userId,
      userData.email,
      userData,
      "Reset User Password",
      `Are you sure you want to reset the password for ${userData.firstName} ${userData.lastName}? A password reset email will be sent to ${userData.email}.`,
    );
  };

  const LockUserAction = (email) => {
    var config = {
      method: "post",
      url:
        process.env.REACT_APP_API_URL + "Operators/LockOperatorUser/" + email,
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config).then(function (response) {
      console.log(response);
      if (response.data.statusCode === 200) {
        toast.success("User Locked");
        getOperatorUsers();
      }
    });
  };

  const LockUser = (userData) => {
    showConfirmation(
      "lock",
      userData.userId,
      userData.email,
      userData,
      "Lock User",
      `Are you sure you want to lock this user (${userData.firstName} ${userData.lastName})?`,
    );
  };

  const UnLockUserAction = (email) => {
    var config = {
      method: "post",
      url:
        process.env.REACT_APP_API_URL + "Operators/UnLockOperatorUser/" + email,
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config).then(function (response) {
      if (response.data.statusCode === 200) {
        toast.success("User Unlocked");
        getOperatorUsers();
      }
    });
  };

  const UnLockUser = (userData) => {
    showConfirmation(
      "unlock",
      userData.userId,
      userData.email,
      userData,
      "Unlock User",
      `Are you sure you want to unlock this user (${userData.firstName} ${userData.lastName})?`,
    );
  };

  const handleEdit = (e) => {
    setIsEdit(true);
    setOperatorInfo({
      email: e.email,
      firstName: e.firstName,
      isActive: e.isActive,
      isLocked: e.isLocked,
      lastName: e.lastName,
      roleId: e.roleId,
      userId: e.userId,
      roleName: e.roleName,
    });
    setErrors({});
    setShow(true);
  };

  const options = [
    {
      selector: (row) => row.firstName,
      name: "First Name",
    },
    {
      selector: (row) => row.lastName,
      name: "Last Name",
    },
    {
      selector: (row) => row.email,
      name: "Email",
      width: "200px",
    },
    {
      selector: (row) => (row.isActive == true ? "Yes" : "No"),
      name: "Active",
      width: "80px",
    },
    {
      selector: (row) => (row.isLocked == true ? "Yes" : "No"),
      name: "Locked",
      width: "80px",
    },
    {
      selector: (row) => row.roleName,
      name: "Role",
    },
    {
      name: "Options",
      selector: (row) => (
        <>
          <OverlayTrigger
            key="reset"
            placement="top"
            overlay={
              <Tooltip id={`tooltip-reset-${row.userId}`}>
                Reset Password
              </Tooltip>
            }
          >
            <button
              className="btn btn-icon btn-sm btn-success cts-btn-success mr-5"
              onClick={() => ResetPassword(row)}
            >
              <MdPassword />
            </button>
          </OverlayTrigger>
          {row.isLocked == true ? (
            <OverlayTrigger
              key="unlock"
              placement="top"
              overlay={
                <Tooltip id={`tooltip-unlock-${row.userId}`}>
                  Unlock User
                </Tooltip>
              }
            >
              <button
                className="btn btn-icon btn-sm btn-danger cts-btn-danger mr-5"
                onClick={() => UnLockUser(row)}
              >
                <AiFillLock />
              </button>
            </OverlayTrigger>
          ) : (
            <OverlayTrigger
              key="lock"
              placement="top"
              overlay={
                <Tooltip id={`tooltip-lock-${row.userId}`}>Lock User</Tooltip>
              }
            >
              <button
                className="btn btn-icon btn-sm btn-primary cts-btn-primary mr-5"
                onClick={() => LockUser(row)}
              >
                <AiFillUnlock />
              </button>
            </OverlayTrigger>
          )}

          <OverlayTrigger
            key="edit"
            placement="top"
            overlay={
              <Tooltip id={`tooltip-edit-${row.userId}`}>Edit User</Tooltip>
            }
          >
            <button
              className="btn btn-icon btn-sm btn-warning cts-btn-warning mr-5"
              onClick={() => handleEdit(row)}
            >
              <TbEdit />
            </button>
          </OverlayTrigger>
          <OverlayTrigger
            key="delete"
            placement="top"
            overlay={
              <Tooltip id={`tooltip-delete-${row.userId}`}>Delete User</Tooltip>
            }
          >
            <button
              className="btn btn-icon btn-sm btn-danger cts-btn-danger"
              onClick={() => DeleteOperatorUser(row)}
            >
              <AiFillDelete />
            </button>
          </OverlayTrigger>
        </>
      ),
      allowOverflow: true,
    },
  ];

  const DeleteOperatorUserAction = (operatorUserId) => {
    console.log(operatorUserId);
    var config = {
      method: "delete",
      url:
        process.env.REACT_APP_API_URL +
        "Operators/DeleteOperatorUser/" +
        operatorUserId,
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          toast.success("User Deleted");
          getOperatorUsers();
        }
      })
      .catch(function (error) {});
  };

  const DeleteOperatorUser = (userData) => {
    // Get current logged-in user ID
    const currentUserId = localStorage.getItem("uTsReD");

    // Check if user is trying to delete themselves
    if (
      currentUserId &&
      userData.userId &&
      parseInt(currentUserId) === parseInt(userData.userId)
    ) {
      toast.info(
        "You cannot delete your own account. Please contact an administrator if you need assistance with account management.",
      );
      return;
    }

    // Proceed with delete confirmation for other users
    showConfirmation(
      "delete",
      userData.userId,
      userData.email,
      userData,
      "Delete User",
      `Are you sure you want to delete this user (${userData.firstName} ${userData.lastName})? This action cannot be undone.`,
    );
  };

  const focusFirstErrorField = (validationErrors) => {
    // Use setTimeout to ensure DOM is updated with error messages before focusing
    setTimeout(() => {
      // Focus on the first field with an error in order: FirstName, LastName, Email, RoleId
      if (validationErrors.FirstName && firstNameRef.current) {
        firstNameRef.current.focus();
      } else if (validationErrors.LastName && lastNameRef.current) {
        lastNameRef.current.focus();
      } else if (validationErrors.Email && emailRef.current) {
        emailRef.current.focus();
      } else if (validationErrors.RoleId && roleIdRef.current) {
        roleIdRef.current.focus();
      }
    }, 100);
  };

  // Map between PascalCase (API errors) and camelCase (state)
  const fieldNameMap = {
    FirstName: "firstName",
    LastName: "lastName",
    Email: "email",
    RoleId: "roleId",
  };

  const handleInputChange = (apiFieldName, value) => {
    const stateFieldName =
      fieldNameMap[apiFieldName] || apiFieldName.toLowerCase();

    setOperatorInfo((prevState) => ({
      ...prevState,
      [stateFieldName]: value,
    }));

    // Clear error for this field when user starts typing (using API field name for errors)
    if (errors[apiFieldName]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[apiFieldName];
        return newErrors;
      });
    }
  };

  const AddOperatorUser = () => {
    // Validate required fields before submission
    const validationErrors = {};
    let hasErrors = false;

    if (!operatorInfo.firstName || operatorInfo.firstName.trim() === "") {
      validationErrors.FirstName = ["The FirstName field is required."];
      hasErrors = true;
    }

    if (!operatorInfo.lastName || operatorInfo.lastName.trim() === "") {
      validationErrors.LastName = ["The LastName field is required."];
      hasErrors = true;
    }

    if (!operatorInfo.email || operatorInfo.email.trim() === "") {
      validationErrors.Email = ["The Email field is required."];
      hasErrors = true;
    }

    if (
      !operatorInfo.roleId ||
      operatorInfo.roleId === 0 ||
      operatorInfo.roleId === "0"
    ) {
      validationErrors.RoleId = ["The Role field is required."];
      hasErrors = true;
    }

    if (hasErrors) {
      setErrors(validationErrors);
      focusFirstErrorField(validationErrors);
      toast.warning("Please review and correct the required fields");
      return;
    }

    // Clear errors if validation passes
    setErrors({});
    console.log("DFVvfd", operatorInfo);
    var config = {};
    isEdit
      ? (config = {
          method: "Patch",
          url:
            process.env.REACT_APP_API_URL +
            "Users/UpdateUser/" +
            operatorInfo.userId,
          headers: {
            "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          data: { ...operatorInfo, roleId: operatorInfo?.roleId?.toString() },
        })
      : (config = {
          method: "POST",
          url: process.env.REACT_APP_API_URL + "Users/AddUser/",
          headers: {
            "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          data: { ...operatorInfo, roleId: operatorInfo?.roleId?.toString() },
        });

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          toast.success(
            isEdit ? "User updated successfully" : "User added successfully",
          );
          getOperatorUsers();
          setShow(false);
          setOperatorInfo({});
          setErrors({});
        } else {
          console.log("FDVfvd", response);
          toast.error(response?.data?.message);
        }
      })
      .catch(function (error) {
        if (error?.response?.data?.errors) {
          const validationErrors = error.response.data.errors;
          setErrors(validationErrors);
          focusFirstErrorField(validationErrors);
          toast.warning("Please review and correct the required fields");
        } else {
          toast.error(
            error?.response?.data?.message ||
              (isEdit ? "Failed to update user" : "Failed to add user"),
          );
        }
      });
  };

  const getOperatorUsers = () => {
    var isOperator = localStorage.getItem("O3rt!05");
    var config = {};
    if (isOperator) {
      var operatorId = localStorage.getItem("oTsReD");
      config = {
        method: "Get",
        url:
          process.env.REACT_APP_API_URL +
          "Operators/GetOperatorUsers/" +
          operatorId,
        headers: {
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
    } else {
      config = {
        method: "Get",
        url:
          process.env.REACT_APP_API_URL +
          "Operators/GetOperatorUsers/" +
          pId.OperatorId,
        headers: {
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
    }

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          setOperatorUsers(response.data.content);
        }
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          window.location = "/Login";
          window.location.reload();
        }
      });
  };

  const getOperatorRoles = (operatorId) => {
    var config = {
      method: "Get",
      url:
        process.env.REACT_APP_API_URL +
        "Operators/GetOperatorRoles/" +
        operatorId,
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          setOperatorRoles(response.data.content);
        }
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          window.location = "/Login";
          window.location.reload();
        }
      });
  };
  useEffect(() => {
    getOperatorUsers();

    getOperatorRoles(pId.OperatorId);
    setOperatorInfo((prevState) => ({
      ...prevState,
      operatorId: pId.OperatorId,
    }));
  }, []);

  // Refetch roles when rolesUpdateKey changes (triggered when roles are added/edited in OperatorRoles)
  useEffect(() => {
    if (rolesUpdateKey !== undefined && rolesUpdateKey > 0) {
      getOperatorRoles(pId.OperatorId);
    }
  }, [rolesUpdateKey, pId.OperatorId]);

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Operator & School Users</h3>
        <div className="align-self-center">
          <button
            className="btn btn-primary btn-sm cts-btn-primary d-flex align-items-center gap-2"
            onClick={handleShow}
          >
            <BsPlusCircleFill size={16} />
            Add User
          </button>
        </div>
      </div>
      <div className="card-body p-0" style={{ minHeight: "300px" }}>
        <DataTable data={operatorUsers} columns={options} />
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit == true ? "Edit " : "Add "} User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-3">
            <div className="col-6">
              <label>
                First Name <span className="text-danger">*</span>
              </label>
              <input
                ref={firstNameRef}
                className={`form-control form-control-sm ${errors.FirstName ? "is-invalid" : ""}`}
                placeholder="First Name"
                value={operatorInfo.firstName || ""}
                onChange={(e) => handleInputChange("FirstName", e.target.value)}
              ></input>
              {errors.FirstName && (
                <div className="text-warning" style={{ fontSize: "0.875rem" }}>
                  {errors.FirstName[0]}
                </div>
              )}
            </div>
            <div className="col-6">
              <label>
                Last Name <span className="text-danger">*</span>
              </label>
              <input
                ref={lastNameRef}
                className={`form-control form-control-sm ${errors.LastName ? "is-invalid" : ""}`}
                placeholder="Last Name"
                value={operatorInfo.lastName || ""}
                onChange={(e) => handleInputChange("LastName", e.target.value)}
              ></input>
              {errors.LastName && (
                <div className="text-warning" style={{ fontSize: "0.875rem" }}>
                  {errors.LastName[0]}
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <label>
                Email <span className="text-danger">*</span>
              </label>
              <input
                ref={emailRef}
                className={`form-control form-control-sm ${errors.Email ? "is-invalid" : ""}`}
                placeholder="Email"
                value={operatorInfo.email || ""}
                onChange={(e) => handleInputChange("Email", e.target.value)}
              ></input>
              {errors.Email && (
                <div className="text-warning" style={{ fontSize: "0.875rem" }}>
                  {errors.Email[0]}
                </div>
              )}
            </div>
            <div className="col-6">
              <label>
                Role <span className="text-danger">*</span>
              </label>
              <select
                ref={roleIdRef}
                className={`form-control form-control-sm ${errors.RoleId ? "is-invalid" : ""}`}
                value={operatorInfo.roleId || 0}
                onChange={(e) => {
                  const value =
                    e.target.value === "0" ? 0 : parseInt(e.target.value);
                  handleInputChange("RoleId", value);
                  setOperatorInfo((prevState) => ({
                    ...prevState,
                    operatorId: pId.OperatorId,
                  }));
                }}
              >
                <option value={0}>-- Select Role --</option>
                {operatorRoles.map((o) => (
                  <option key={o.roleId} value={o.roleId}>
                    {o.roleName}
                  </option>
                ))}
              </select>
              {errors.RoleId && (
                <div className="text-warning" style={{ fontSize: "0.875rem" }}>
                  {errors.RoleId[0]}
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            className="btn btn-primary btn-sm cts-btn-secondary"
          >
            Close
          </Button>
          <button
            variant="primary"
            onClick={() => AddOperatorUser()}
            className="btn btn-primary btn-sm cts-btn-primary"
          >
            Save Changes
          </button>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Dialog */}
      <Modal show={showConfirmDialog} onHide={handleCloseConfirm} centered>
        <Modal.Header closeButton>
          <Modal.Title>{confirmAction.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{confirmAction.message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseConfirm}
            className="btn btn-sm cts-btn-secondary"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            className="btn btn-sm cts-btn-primary"
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OperatorUsers;
